import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import * as React from 'react';
import { TabContent } from 'reactstrap';
import styled from 'styled-components';
import { DropdownData } from '../../../components_v2/dropdown/model/Model';
import { CompanyStatus } from '../../client-companies/model/Model';
import { FetchKey } from '../MapView';
import TabPins, { PinId } from './TabPins';
import { TOOLBARS_HEIGHT } from '../../globals/defaultToolbar/style/Style';
import { DefaultButton } from '../../../styles/global/css/GlobalButton';
import { PastelPrimaryColor, PrimaryColor } from '../../../styles/global/css/Utils';

const ToggleButton = styled(DefaultButton) <{ isOpen: boolean }>`
	margin: 0;
	display: flex;
	align-items: center;
	padding: 5px;
	height: unset;
	background: ${p => !p.isOpen ? 'transparent' : PastelPrimaryColor};
	border: ${p => !p.isOpen ? `1px solid color-mix(in oklab, ${PrimaryColor} 30 %, white)` : 'none'};
	&:hover {
		background: color-mix(in oklab, ${PastelPrimaryColor}, black 10%);
	}
`;

export function ModalLeftToggle(props: { isOpen: boolean, onClick: () => void }): JSX.Element {
	// The page re-renders before its toolbar effect pushes the new icon, so mirror the flag locally to flip on click
	const [isOpen, setIsOpen] = React.useState(props.isOpen);
	React.useEffect(() => setIsOpen(props.isOpen), [props.isOpen]);
	return <ToggleButton isOpen={props.isOpen} type='button' onClick={() => {
		setIsOpen(open => !open);
		props.onClick();
	}}>
		{isOpen ? <PanelLeftClose size={14} color={PrimaryColor} /> : <PanelLeftOpen size={14} color={PrimaryColor} />}
	</ToggleButton>;
}

export default function ModalLeftFilter(props: {
	isModalOpen?: boolean;
	setIsModalOpen?: (value: boolean) => void;
	all_postcodes: DropdownData<string | undefined>[];
	all_cities: DropdownData<string | undefined>[];
	all_countries: DropdownData<string | undefined>[];
	changeFilters: (key: string, value) => void;
	updatePieFilter: (label: string, value, all_updated?: boolean) => void;
	pieFilter: {
		[key: string]: {
			index: number;
			isActive: boolean;
			color: string;
			value: [number, number];
		};
	};
	statuses: CompanyStatus[];
	fetchFor: (key: FetchKey) => void;
	tabType: FetchKey;
	setTabType: (v: PinId) => void;
}) {
	const { tabType, setTabType } = props;
	const isOpen = props.isModalOpen ?? true;
	const [activeTab] = React.useState(1);

	return (
		<div
			className="filter-modal"
			style={{ width: '275px', top: 0, left: -275, height: '100%' }}
		>
			<div className={isOpen ? 'box-filter-modal' : 'd-none'}>
				{/* <Nav tabs style={{ position: 'sticky', top: 0, zIndex: 1 }}>
					<NavItem>
						<NavLink
							className={activeTab === 1 ? 'active' : ''}
							onClick={() => setActiveTab(1)}
						>
							<Translate id="Markers" />
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							className={activeTab === 2 ? 'active' : ''}
							onClick={() => setActiveTab(2)}
						>
							<Translate id="map_datas" />
						</NavLink>
					</NavItem>
				</Nav> */}
				<TabContent
					activeTab={activeTab}
					style={{ height: `calc(100vh - ${TOOLBARS_HEIGHT + 12}px)` }}
				>
					<TabPins
						handleTabRange={setTabType}
						tabType={tabType}
					/>
					{/* <TabFilter
						all_postcodes={props.all_postcodes}
						all_cities={props.all_cities}
						all_countries={props.all_countries}
						changeFilters={props.changeFilters}
						status={props.statuses}
						updatePieFilter={props.updatePieFilter}
						pieFilter={props.pieFilter}
						fetchFor={props.fetchFor}
					/> */}
				</TabContent>
			</div>
		</div>
	);
}
